import React from 'react';
import { Tooltip } from 'antd';
import { LockFilled } from '@ant-design/icons';

type DefaultFactorColumnProps = {
  text: string;
  isDefault?: boolean;
  tooltipTitle?: string;
  className?: string;
};

export const DefaultFactorColumn = ({
  text,
  isDefault = false,
  tooltipTitle = 'Default Factor',
  className,
}: DefaultFactorColumnProps) => {
  return (
    <span className={className}>
      {text}
      {isDefault ? (
        <Tooltip title={tooltipTitle}>
          <LockFilled style={{ color: 'rgb(67, 126, 247)' }} />
        </Tooltip>
      ) : null}
    </span>
  );
};
